<ew-mat-dialog-custom ngClass="overflow-hidden">
  <main class="mx-10 mt-8">
    <h1>{{ 'settingsUsers:inviteNewUser' | translate }}</h1>
    <form [formGroup]="newUser">
      <div class="flex flex-col mt-4 overflow-hidden">
        <mat-form-field>
          <mat-label> {{ 'settingsUsers:formField1' | translate }} </mat-label>
          <input matInput type="text" formControlName="fullName" />

          <mat-error *ngIf="newUser.controls['fullName'].errors">
            <span *ngIf="newUser.controls['fullName'].errors['required']">
              <strong>
                {{ 'shared:isRequired' | translate }}
              </strong>
            </span>

            <span *ngIf="newUser.controls['fullName'].errors['minlength']">
              <strong>
                {{
                  newUser.controls['fullName'].errors['minlength']
                    | errorMinValue
                }}
              </strong>
            </span>
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label> {{ 'settingsUsers:formField2' | translate }} </mat-label>
          <input matInput type="text" formControlName="email" />

          <mat-error *ngIf="newUser.controls['email'].errors">
            <span *ngIf="newUser.controls['email'].errors['required']">
              <strong>
                {{ 'shared:isRequired' | translate }}
              </strong>
            </span>

            <span *ngIf="newUser.controls['email'].errors['email']">
              <strong>
                {{ 'shared:formatEmail' | translate }}
              </strong>
            </span>
          </mat-error>
        </mat-form-field>
      </div>

      <treo-message
        class="my-3"
        [appearance]="treoMessage.appearance"
        [showIcon]="treoMessage.showIcon"
        [showButtonClose]="treoMessage.showButtonClose"
        [type]="treoMessage.type">
        <div>
          <b>{{ 'settingsUsers:alertAdminAccessTitle' | translate }} </b>
          {{ 'settingsUsers:alertAdminAccess' | translate }}
        </div>
      </treo-message>

      <hr class="my-4" />

      <div class="flex justify-end gap-4">
        <button
          mat-stroked-button
          class="rounded-lg xs:w-full w-20"
          color="secondary"
          (click)="dialogRef.close()">
          {{ 'shared:cancel' | translate }}
        </button>

        <button
          mat-flat-button
          class="rounded-lg xs:w-full w-40"
          color="primary"
          [disabled]="!validations"
          (click)="submit()">
          {{ 'settingsUsers:inviteNewUser' | translate }}
        </button>
      </div>
    </form>
  </main>
</ew-mat-dialog-custom>
